import { useState } from "react";
import { HTMLMotionProps, motion } from "motion/react";

type PreloadImageProps = HTMLMotionProps<"img"> & {
    onLoadFinish?: () => void;
};

const PreloadImage = ({
    src,
    className,
    animate,
    initial,
    onLoadFinish,
    onLoad,
    ...props
}: PreloadImageProps) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <motion.img
            src={src}
            className={className}
            initial={initial}
            animate={loaded ? animate : initial}
            onLoad={(event) => {
                setLoaded(true);
                onLoad?.(event);
                onLoadFinish?.();
            }}
            {...props}
        />
    );
};

export default PreloadImage;
